import * as React from "react";
import { ActionButton, Breadcrumb, ChoiceGroup, Dialog, DialogFooter, DialogType, IButtonProps, IChoiceGroupOption, IChoiceGroupStyles, Icon, IDialogContentProps, IIconProps, IRenderFunction, mergeStyles, Panel, PanelType, PrimaryButton, Spinner, SpinnerSize, Stack, TooltipDelay, TooltipHost } from "@fluentui/react";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { ISearchOpenFileInfo } from "../../interfaces/ISearchOpenFileInfo";
import { IFilePanelInfo } from "../../interfaces/IFilePanelInfo";
import { SearchOpenExtensionHelper } from "../helpers/SearchOpenExtensionHelper";
import { DocubirdCache, extensions, officeFileType, OneNoteProgId, sharePointInternalFileName, validPdfExtensions, validPreviewExtension, validSigningRequestExtensions } from "../../config/constants";
import {
  checkIfFileOrFolderExist,
  getDriveRootWebUrl,
  getFileItemInfo,
  getFilePdfByteContent,
  getItem,
  getItemCustomSelect,
  getListItemWebUrl,
  getParentWebURL,
} from "../../services/GraphService";
import authModule from "../../../../utilities/AuthModule";
import { RootState } from "../../redux";
import { connect, ConnectedProps } from "react-redux";
import { ModeEnum } from "../enums/modeEnum";
import { FileTypeEnum } from "../enums/fileTypeEnum";
import { EmailCreatorFactory } from "../helpers/emailAttachment/EmailCreatorFactory";
import { FileDownLoader } from "../helpers/fileDownloader";
import { changeExtensionToPdf, removeExtension } from "../helpers/stringHelper";
import { addPinnedItem, getPinnedFileIndex, MovePinnedItemDown, MovePinnedItemUp, removePinnedItem } from "../../redux/modules/pinnedItems";
import { IStoreItem } from "../../interfaces/IStoredItem";
import { removeRecentItem as removeRecentItemRedux, addRecentItem } from "../../redux/modules/recentItems";
import { IDriveInfo } from "../../interfaces/IDriveInfo";
import { logger } from "../../../../utilities/logger";
import { isMobile } from "../../styles/mobileStyles";
import { setExpandedItem } from "../../redux/modules/expanders";
import { expanderConstants } from "../../redux/models/constants/expanders";
import { IExpander } from "../../redux/models/IExpander";
import PreviewFile from "../directoryComponents/PreviewFile";
import { IFileItem } from "../../interfaces/IFileItem";
import { useCheckPiiMutation, useGraphItemPiiMutation } from "../_v2/redux/api/local/api-pii-slice";
import { WebPanel } from "../_v2/_shared/WebPanel/WebPanel";
import { AutomationPanel } from "../_v2/components/Panels/AutomationPanel/AutomationPanel";
import { CheckinTypes, ConvertAndSaveAsPDFRequest, FilePreCommitRequest, HookType, PIIResult } from "../_v2/redux/api/local/api-local-interfaces";
import { CMFileInfoPanel, InfoPanelMode } from "../../../../contentManager/Panels/CMFileInfoPanel";
import generalModule from "../../../../utilities/GeneralModule";
import { SharePointInputData } from "../../interfaces/props/SharePointInputData";
import { useLazyGetFileByIDQuery, useLazyRenderListAsStreamByIDQuery, useLazySendSharepointItemToRecyclebinQuery, useLazyUnpublishItemQuery } from "../_v2/redux/api/sharepoint/api-sharepoint-slice";
import { ComponentTypes } from "../../config/config";
import { brandedActionButtonIconStyles, breadCrumbContainerStyles, breadCrumbStyles, confirmDeleteButtonStyles } from "../../config/controlStyles";
import { OpenInBrowser, OpenPdfInBrowser } from "../../../../utilities/BrowserUtils";
import { currentSharepointFolderUserPermissions } from "../../redux/models/reduxModels";
import { getFilePreCommitInfo, getUserEffectivePermissions, getUserEffectivePermissionsFromMask } from "../../services/SharePointRestServices";
import { CMVersionHistoryModal } from "../../../../contentManager/Panels/CMVersionHistoryModal";
import { CMCheckinModal } from "../../../../contentManager/Panels/CMCheckinModal";
import { setCanViewFolder } from "../../redux/modules/currentSharepointFolder";
import { IFilePreCommitResult } from "../../interfaces/IFilePreCommitResult";
import { VersionSelectorMinMajOnly } from "../_v2/_shared/VersionSelector/VersionSelectorMinMajOnly";
import { OneDriveOverWriteEnum } from "../enums/oneDriveOverWriteEnum";
import { apiFileConvertAndSaveAsPDF } from "../../services/ApiService";
import { SigningPanel } from "../_v2/components/Panels/SigningPanel/SigningPanel";
import { CacheHelper } from "../../../../utilities/CacheHelper";
import { getValidHooks } from "../../services/HooksService";
import { OneDriveUrlHelper } from "../helpers/oneDriveUrlHelper";
import * as microsoftTeams from "@microsoft/teams-js"
import shareToTeams from "../../../../contentManager/Services/ShareToTeamsService";
import { CMFileSharePanel, SharePanelMode } from "../../../../contentManager/Panels/CMFileSharePanel";
import { getFilenameFromTemplate } from "../../../../utilities/FileNameDownloadTemplateHelper";
import { getItemPathArray } from "../helpers/UrlHelper";
import { ArrowBetweenDown20Regular } from "../_v2/components/SvgIcons/ArrowBetweenDown20Regular";
import { ArrowBetweenUp20Regular } from "../_v2/components/SvgIcons/ArrowBetweenUp20Regular";
import { ArrowDownload20Regular } from "../_v2/components/SvgIcons/ArrowDownload20Regular";
import { ArrowExportUp20Regular } from "../_v2/components/SvgIcons/ArrowExportUp20Regular";
import { Checkmark20Regular } from "../_v2/components/SvgIcons/Checkmark20Regular";
import { Delete20Regular } from "../_v2/components/SvgIcons/Delete20Regular";
import { DeleteArrowBack20Regular } from "../_v2/components/SvgIcons/DeleteArrowBack20Regular";
import { Dismiss20Regular } from "../_v2/components/SvgIcons/Dismiss20Regular";
import { DocumentArrowRight20Regular } from "../_v2/components/SvgIcons/DocumentArrowRight20Regular";
import { DocumentGlobe20Regular } from "../_v2/components/SvgIcons/DocumentGlobe20Regular";
import { DocumentLandscapeSplitHint20Regular } from "../_v2/components/SvgIcons/DocumentLandscapeSplitHint20Regular";
import { DocumentPdf20Filled } from "../_v2/components/SvgIcons/DocumentPdf20Filled";
import { DocumentPdf20Regular } from "../_v2/components/SvgIcons/DocumentPdf20Regular";
import { DocumentSignature20Regular } from "../_v2/components/SvgIcons/DocumentSignature20Regular";
import { FlowDot20Regular } from "../_v2/components/SvgIcons/FlowDot20Regular";
import { Info20Regular } from "../_v2/components/SvgIcons/Info20Regular";
import { Link20Regular } from "../_v2/components/SvgIcons/Link20Regular";
import { LinkAdd20Regular } from "../_v2/components/SvgIcons/LinkAdd20Regular";
import { MailAttach20Regular } from "../_v2/components/SvgIcons/MailAttach20Regular";
import { MailLink20Regular } from "../_v2/components/SvgIcons/MailLink20Regular";
import { Open20Regular } from "../_v2/components/SvgIcons/Open20Regular";
import { OpenFolder20Regular } from "../_v2/components/SvgIcons/OpenFolder20Regular";
import { PeopleTeam20Regular } from "../_v2/components/SvgIcons/PeopleTeam20Regular";
import { Pin20Regular } from "../_v2/components/SvgIcons/Pin20Regular";
import { PinOff20Regular } from "../_v2/components/SvgIcons/PinOff20Regular";
import { Share20Regular } from "../_v2/components/SvgIcons/Share20Regular";
import { Stack20Regular } from "../_v2/components/SvgIcons/Stack20Regular";
import { StackOff20Regular } from "../_v2/components/SvgIcons/StackOff20Regular";

const choiceGroupStyles: IChoiceGroupStyles = { label: { fontSize: 16 } };

const mapStateToProps = (state: RootState) => {
  return {
    mode: state.mode.mode,
    workingDirectories: state.workingDirectories.workingDirectories,
    currentDirectory: state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1],
    pinned: state.pinned,
    user: state.user,
    recent: state.recent,
    expanders: state.expanders,
    currentSharepointFolder: state.currentSharepointFolder,
    oneDriveRootDetails: state.workingDirectories.oneDriveRootDetails,
    tenantDisableFileRename: state.tenantInfo?.disableFileRename,
    hideAutoPreview: state.tenantInfo?.hideAutoPreview,
    enableSharing: state.tenantInfo?.enableSharing,
    siteInfo: state.tenantInfo?.sites
  };
};

const mapDispatchToProps = {
  addPinnedItem,
  removePinnedItem,
  removeRecentItemRedux,
  addRecentItem,
  setExpandedItem,
  setCanViewFolder,
  MovePinnedItemDown,
  MovePinnedItemUp
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface FileOptionPanelProps extends PropsFromRedux {
  info: IFilePanelInfo;
  dismissPanel: () => void;
  showFileDeletedDialog?: () => void;
  updateFilePii?: (fileOptionPanelInfo: IFilePanelInfo, piiResult: PIIResult) => void;
  fileUpdated?: (fileOptionPanelInfo: IFilePanelInfo, newFilename: string) => void;
  fileDeleted?: (fileOptionPanelInfo: IFilePanelInfo) => void;
}

// const unpinIcon: IIconProps = { iconName: "Unpin" };
// const pinIcon: IIconProps = { iconName: "Pin" };
// const attachIcon: IIconProps = { iconName: "Attach" };
// const linkIcon: IIconProps = { iconName: "AddLink" };
// const browseIcon: IIconProps = { iconName: "BrowserTab" };
// const openInAppIcon: IIconProps = { iconName: "CloneToDesktop" };
// const removeFromRecentIcon = { iconName: "RemoveFromTrash" };
// const pdfIcon = { iconName: "PDF" };
// const privacySensitiveIcon = { iconName: "Unlock" };
// const redactIcon = { iconName: "PageEdit" };
// const documentApprovalIcon = { iconName: "DocumentApproval" };
// const SigningRequestIcon = { iconName: "InsertSignatureLine" };
// const fileInfoIcon = { iconName: "Info" };
// const fileReplaceIcon = { iconName: "PostUpdate" };
// const fileDeleteIcon = { iconName: "Delete" };
// const fileDownloadIcon = { iconName: "Download" };
// const versionHistoryIcon = { iconName: "History" };
// const filePublishIcon = { iconName: "PublishContent" };
// const fileUnpublishIcon = { iconName: "UnpublishContent" };
// const iconUp = { iconName: "Up" }
// const iconDown = { iconName: "Down" }
// const shareIcon = { iconName: "Share" };
// const copyLinkIcon = { iconName: "Link" };

const FileOptionPanel: React.FunctionComponent<FileOptionPanelProps> = props => {
  const languageStrings = React.useContext(LanguageContext);
  const [teamsContext, setTeamsContext] = React.useState(null);
  const [item, setItem] = React.useState<IFileItem>(null);
  const [browseFileInfo, setBrowseFileInfo] = React.useState<ISearchOpenFileInfo>(null);
  const [emailCreatorfactory] = React.useState<EmailCreatorFactory>(
    new EmailCreatorFactory(props?.currentDirectory?.isTeamsFolder)
  );
  const [isFilePinned, setIsFilePinned] = React.useState<boolean>(false);
  const [pinnedFileIndex, setPinnedFileIndex] = React.useState<number>(-1);
  const [isAwaitingPinAction, setIsAwaitingPinAction] = React.useState<boolean>(false);
  const [isAwaitingRecentAction, setIsAwaitingRecentAction] = React.useState<boolean>(false);
  const [isBusyDownloadingPDF, setIsBusyDownloadingPDF] = React.useState<boolean>(false);
  const [isBusySavingPDF, setIsBusySavingPDF] = React.useState<boolean>(false);
  const [isSavingDuplicatePDF, setIsSavingDuplicatePDF] = React.useState<boolean>(false);
  const [isOpeningFileLocation, setIsOpeningFileLocation] = React.useState<boolean>(false);
  const [isErrorDialogHidden, setIsErrorDialogHidden] = React.useState<boolean>(true);
  const [dialogContent, setDialogContent] = React.useState<IDialogContentProps>(null);
  const [unknownItem, setUnknownItem] = React.useState<boolean>(false);
  const [piiInfo, setPiiInfo] = React.useState<PIIResult>(props.info.pii);
  const [infoPanelMode, setInfoPanelMode] = React.useState<InfoPanelMode>();
  const [filePathArray, setFilePathArray] = React.useState<string[]>();

  const [showRedact, setShowRedact] = React.useState<boolean>(false);
  const [isCheckingPii, setIsCheckingPii] = React.useState<boolean>(false);
  const [isDeletingFile, setIsDeletingFile] = React.useState<boolean>(false);
  const [isDownloadingFile, setIsDownloadingFile] = React.useState<boolean>(false);
  const [isRedactingData, setIsRedactingData] = React.useState<boolean>(false);
  const [refreshPreview, setRefreshPreview] = React.useState<boolean>(false);
  const [webAddinItem, setWebAddinItem] = React.useState<any>();
  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);
  const [userPermissions, setUserPermissions] = React.useState<currentSharepointFolderUserPermissions>();

  const [spFileItem, setSpFileItem] = React.useState<any>();
  const [showVersionHistoryDialog, setShowVersionHistoryDialog] = React.useState(false);
  const [publishButton, setPublishButton] = React.useState<JSX.Element>();
  const [unpublishButton, setUnpublishButton] = React.useState<JSX.Element>();
  const [versionHistoryButton, setVersionHistoryButton] = React.useState<JSX.Element>();
  const [isPublishing, setIsPublishing] = React.useState<boolean>(false);
  const [isUnpublishing, setIsUnpublishing] = React.useState<boolean>(false);
  const [showCheckinDialog, setShowCheckinDialog] = React.useState(false);
  const [fileLinkUrl, setFileLinkUrl] = React.useState("");

  const [selectedOverwriteOption, setSelectedOverwriteOption] = React.useState("");
  const [selectedCheckinType, setSelectedCheckinType] = React.useState<CheckinTypes>(null);
  const [showSelectVersion, setShowSelectVersion] = React.useState(false);

  const [messageSendInProcess, setMessageSendInProcess] = React.useState<boolean>(false);

  const [overwriteOptions] = React.useState<IChoiceGroupOption[]>([
    { key: OneDriveOverWriteEnum.rename.toString(), text: languageStrings.Rename },
    { key: OneDriveOverWriteEnum.replace.toString(), text: languageStrings.Replace }
  ]);

  const [fileName, setFileName] = React.useState(props.info.name);

  const [approvalFlowsAvailable, setApprovalFlowsAvailable] = React.useState(false);
  const [signingFlowsAvailable, setSigningFlowsAvailable] = React.useState(false);

  const isInOneDrive = React.useRef(false);

  const [checkPiiMutation, { isLoading: isLoadingCheckPii }] = useCheckPiiMutation();
  const [checkGraphPiiMutation, { isLoading: isLoadingCheckGraphPii }] = useGraphItemPiiMutation();
  const [sendSharepointItemToRecyclebin] = useLazySendSharepointItemToRecyclebinQuery();
  const [getFileByID] = useLazyGetFileByIDQuery();
  const [unpublishItem] = useLazyUnpublishItemQuery();
  const [renderListAsStreamByID] = useLazyRenderListAsStreamByIDQuery();

  React.useEffect(() => {
    if (props?.currentDirectory) {
      isInOneDrive.current = props?.currentDirectory.type == ComponentTypes.OneDrive || props?.currentDirectory.type == ComponentTypes.OneDriveSubFolder;
    }
  }, [props?.currentDirectory]);

  React.useEffect(() => {
    const validHooks = props.user?.tenantEnableApprovalHooks || CacheHelper.get(DocubirdCache.signingEnabled) === true
      ? getValidHooks(CacheHelper.get(DocubirdCache.hooks), props?.currentDirectory)
      : [];

    setApprovalFlowsAvailable(props.user?.tenantEnableApprovalHooks && validHooks.filter(h => h.typeId === HookType.Approval || h.typeId === HookType.BatchApproval || h.typeId === HookType.Generic).length > 0);
    setSigningFlowsAvailable(CacheHelper.get(DocubirdCache.signingEnabled) === true && validHooks.filter(h => h.typeId === HookType.Sign).length > 0);
  }, [props.currentDirectory, props.user]);

  React.useEffect(() => {
    if (props?.mode === ModeEnum.contentManagerTeams) {
      microsoftTeams.getContext((context) => {
        setTeamsContext(context);
      });
    }
  }, [props?.mode]);

  React.useEffect(() => {
    setFileName(props.info.name);
    setPiiInfo(props.info.pii);
    setShowRedact(props.user.tenantEnableRedaction && props.info.pii?.piiDetected && props.info.fileType === extensions.pdf);

    if (props.info.isOpen) {
      if (item) setItem(null);

      const setupAsyncWrapper = async () => {
        try {
          setAsPinnedFromHomePage();
          setBrowseFileInfo(SearchOpenExtensionHelper.determineOfficeFileType(props.info.fileType));
          if (props.info.itemId) {
            const exists = await checkIfFileOrFolderExist({ driveId: props.info.driveId, id: props.info.itemId });

            if (!exists) {
              if (props.info.isRecentItem) {
                removeRecentItem(props.info.itemId);
              }
              else {
                unpinFile(props.info.itemId);
                props.dismissPanel();
              }
              props.showFileDeletedDialog();
              return;
            }
            await setItemWithExistingGraphId();
            return;
          }
          else {
            await setItemWithSharepointId();
          }
        } catch (e) {
          logger(e, "FileOptionPanel.tsx (useEffect)");
        }
      };

      setupAsyncWrapper();
    }
  }, [props.info]);

  React.useEffect(() => {
    if (item) {
      const pinnedItemIndex: number = getPinnedFileIndex(item?.id, props.pinned.pinnedItems);
      setIsFilePinned(pinnedItemIndex > -1);
      setPinnedFileIndex(pinnedItemIndex);
    }
  }, [item, props.pinned?.pinnedItems]);

  React.useEffect(() => {
    if (props.fileUpdated) {
      props.fileUpdated(props.info, fileName)
    }
  }, [fileName]);

  React.useEffect(() => {
    if (webAddinItem) {
      setFilePathArray(getItemPathArray(webAddinItem.listItemWebUrl, props.workingDirectories?.some(dir => dir?.type === ComponentTypes.Docubird)));

      getSPFileByID();
      if (props.info.fileType === "url") {
        (async () => {
          const listItem: any = await getRenderListItemByID();
          if (listItem) {
            setFileLinkUrl(listItem._ShortcutUrl);
          }
        })();
      }
    }
  }, [webAddinItem, props.info.fileType]);

  const getRenderListItemByID = async (): Promise<any | undefined> => {
    try {
      const results = await renderListAsStreamByID({
        siteUrl: webAddinItem.sharepointIds.siteUrl,
        sharePointListId: webAddinItem.sharepointIds.listId,
        accessToken: isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
        Id: props.info.renderItemID ?? webAddinItem.sharepointIds?.listItemId,
        serverRelativePath: props.info.serverRelativePath
      }).unwrap();

      if (results?.ListData?.Row?.length > 0) {
        return results?.ListData?.Row[0];
      }
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (getRenderListItemByID)");
    }
    return undefined;
  }

  const getSPFileByID = async () => {
    try {
      setSpFileItem(await getFileByID({
        siteUrl: webAddinItem.sharepointIds.siteUrl,
        uniqueId: webAddinItem.sharepointIds.listItemUniqueId,
        accessToken: isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken()
      }).unwrap());
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (getSPFileByID)");
    }
  }

  React.useEffect(() => {
    if (spFileItem) {
      if (!spFileItem.CheckoutUser && spFileItem.MinorVersion > 0 && props.currentSharepointFolder?.enableMinorVersions && props.currentSharepointFolder?.userPermissions?.canEditListItem) {
        setPublishButton(<React.Fragment>
          <Stack horizontal>
            <ActionButton
              // iconProps={filePublishIcon}
              onRenderIcon={() => <ArrowExportUp20Regular />}
              allowDisabledFocus
              onClick={() => {
                setIsPublishing(true);
                setShowCheckinDialog(true);
              }
              }
            >
              {languageStrings.Publish}
            </ActionButton>
            {isPublishing && <Spinner size={SpinnerSize.small} />}
          </Stack>
          {showCheckinDialog &&
            <CMCheckinModal
              showDialog={showCheckinDialog}
              isPublish={true}
              closeDialog={() => {
                setIsPublishing(false);
                setShowCheckinDialog(false);
              }}
              closeOnSuccess={async () => {
                setShowCheckinDialog(false);
                await getSPFileByID();
                setIsPublishing(false);
              }}
              selectedAddInItems={[spFileItem]}
              isInOneDrive={false}
            />}
        </React.Fragment>
        )
      } else {
        setPublishButton(null);
      }

      if (!spFileItem.CheckoutUser && spFileItem.MajorVersion > 0 && spFileItem.MinorVersion === 0 && props.currentSharepointFolder?.enableMinorVersions && props.currentSharepointFolder?.userPermissions?.canEditListItem) {
        setUnpublishButton(<Stack horizontal>
          <ActionButton
            // iconProps={fileUnpublishIcon}
            onRenderIcon={() => <StackOff20Regular />}
            allowDisabledFocus
            onClick={async () => {
              setIsUnpublishing(true);
              await onUnpublishItem();
              await getSPFileByID();
              setIsUnpublishing(false);
            }
            }
          >
            {languageStrings.Unpublish}
          </ActionButton>
          {isUnpublishing && <Spinner size={SpinnerSize.small} />}
        </Stack>)
      } else {
        setUnpublishButton(null);
      }

      if (props.currentDirectory?.type && props.currentDirectory.type !== ComponentTypes.SharePointList && spFileItem?.ProgId !== OneNoteProgId && props.currentSharepointFolder?.userPermissions?.canViewVersions) {
        setVersionHistoryButton(<React.Fragment>
          <Stack horizontal>
            <ActionButton
              // iconProps={versionHistoryIcon}
              onRenderIcon={() => <Stack20Regular />}
              allowDisabledFocus
              onClick={() => {
                setShowVersionHistoryDialog(true);
              }}
            >
              {languageStrings.VersionHistory}
            </ActionButton>
          </Stack>
          {showVersionHistoryDialog && <CMVersionHistoryModal showDialog={showVersionHistoryDialog} closeDialog={() => setShowVersionHistoryDialog(false)} selectedAddinItem={spFileItem} isInOneDrive={false} />}
        </React.Fragment>)
      } else {
        setVersionHistoryButton(null);
      }
    } else {
      setPublishButton(null);
      setUnpublishButton(null);
      setVersionHistoryButton(null);
    }

  }, [spFileItem, props.currentSharepointFolder, props.currentDirectory, isPublishing, isUnpublishing, showCheckinDialog, showVersionHistoryDialog])

  const onUnpublishItem = async () => {
    try {
      await unpublishItem({
        siteUrl: webAddinItem?.sharepointIds.siteUrl,
        uniqueId: webAddinItem?.sharepointIds.listItemUniqueId,
        accessToken: await authModule.getSharePointAccessToken(),
      }).unwrap();
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (onUnpublishItem)");
    }
  }

  const showErrorDialog = (title: string, subtitle: string) => {
    const dialogContentProps: IDialogContentProps = {
      type: DialogType.largeHeader,
      title: title,
      closeButtonAriaLabel: "Close",
      subText: subtitle
    };
    setDialogContent(dialogContentProps);
    setIsErrorDialogHidden(false);
  }

  const checkIfInOneDrive = (webUrl: string) => {
    return props.user?.oneDriveWebUrl && webUrl?.startsWith(props.user.oneDriveWebUrl);
  }

  const updateUserPermissions = async (webUrl: string, listId: string, listItemUniqueId: string, itemWebUrl: string) => {
    let permissions: currentSharepointFolderUserPermissions;
    if (props.info.permMask) {
      permissions = getUserEffectivePermissionsFromMask(props.info.permMask);
    }

    if (!permissions) {
      const accessToken: string = await (checkIfInOneDrive(itemWebUrl) ? authModule.getOneDriveAccessToken() : authModule.getSharePointAccessToken());
      permissions = await getUserEffectivePermissions(accessToken, webUrl, listId, listItemUniqueId);
    }

    setUserPermissions(permissions);
    props.setCanViewFolder({
      ...props.currentSharepointFolder,
      userPermissions: permissions ? permissions : { ...props.currentSharepointFolder.userPermissions }
    });
  }

  const setItemWithExistingGraphId = async () => {
    const fileItem = await getItem(
      await authModule.getGraphAccessToken(),
      props.info.driveId,
      props.info.itemId,
      "listItem($select=webUrl)"
    );
    if (fileItem) {
      const addInItem = { sharepointIds: { ...fileItem.sharepointIds }, name: fileItem.name, webUrl: fileItem.webUrl, listItemWebUrl: fileItem.listItem?.webUrl };
      await updateUserPermissions(addInItem.sharepointIds?.siteUrl, addInItem.sharepointIds?.listId, addInItem.sharepointIds?.listItemUniqueId, addInItem.webUrl);
      setWebAddinItem(addInItem);
      setItem({ id: props.info.itemId, webUrl: fileItem.webUrl, driveId: props.info.driveId });
    }
    else {
      setUnknownItem(true);
    }
  };

  const setItemWithSharepointId = async () => {
    // The Sharepoint file Id does not help for graph queries so need to get the graphId   
    const fileItem = await getFileItemInfo(getDriveInfo(), props.info.name, "id,name,webUrl,sharepointIds", "listItem($select=webUrl)");
    if (fileItem) {
      const addInItem = { sharepointIds: { ...fileItem.sharepointIds }, name: fileItem.name, webUrl: fileItem.webUrl, listItemWebUrl: fileItem.listItem?.webUrl };
      await updateUserPermissions(addInItem.sharepointIds?.siteUrl, addInItem.sharepointIds?.listId, addInItem.sharepointIds?.listItemUniqueId, addInItem.webUrl);
      setWebAddinItem(addInItem);
      setItem({ id: fileItem.id, driveId: props.info.driveId, webUrl: fileItem.webUrl });
    } else {
      setUnknownItem(true);
    }
  };

  const getDriveInfo = (): IDriveInfo => {
    return !props.info.folderId
      ? { id: props.info.driveId, driveId: null }
      : { id: props.info.folderId, driveId: props.info.driveId };
  };

  const setAsPinnedFromHomePage = () => {
    setIsFilePinned(props?.info?.isFromPinnedItems);
  };

  const saveToRecent = async () => {
    const recentItem: IStoreItem = {
      driveId: props.info.driveId,
      name: props.info.name,
      extension: props.info.fileType,
      folderId: props.info.folderId,
      itemId: item?.id,
      fileType: FileTypeEnum.file,
      filePath:
        props.info?.filePath ??
        `[${languageStrings.Files}] ${props.workingDirectories.map(x => x.displayName).join("/")}`,
      datePinned: new Date(),
      lastModifiedDateTime: props.info.lastModifiedDateTime,
      modifiedBy: props.info.modifiedBy
    };
    props.addRecentItem(props.user.account.accountId, [recentItem]);
  };

  const openParentWebURLInBrowser = async () => {
    setIsOpeningFileLocation(true);
    try {
      const webUrl = await getParentWebURL(item?.driveId, item?.id);
      if (webUrl) {
        OpenInBrowser(webUrl);
      }
      else {
        showErrorDialog(languageStrings.FileLocationUnknown, languageStrings.FileLocationError);
      }
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (openParentWebURLInBrowser)");
    }
    setIsOpeningFileLocation(false);
  }

  const openInWebView = async () => {
    try {
      await saveToRecent();
      if (props.info.fileType === "url" && fileLinkUrl) {
        window.open(fileLinkUrl, "_blank");
        return;
      }

      if (props.info.fileType?.toLowerCase() === extensions.pdf) {
        OpenPdfInBrowser(props.user.account, item.driveId, item.id, checkIfInOneDrive(item.webUrl));
      } else {
        OpenInBrowser(item.webUrl);
      }
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (openInWebView)");
    }
  };

  const openInApp = React.useCallback(async () => {
    const driveId: string = props.info.driveId;
    const itemId: string = item?.id;

    try {
      if (browseFileInfo.type === officeFileType.App) {
        const file = driveId && itemId && await getItemCustomSelect(await authModule.getGraphAccessToken(), driveId, itemId, "name,sharepointIds");
        if (file?.sharepointIds) {
          const fileId: string = file.sharepointIds.listItemUniqueId;
          const fileName: string = file.name;
          const userEmail: string = props.user.account.username;
          const userId: string = props.user.account.uniqueId;
          const siteId: string = file.sharepointIds.siteId;
          const listId: string = file.sharepointIds.listId;
          const webUrl: string = file.sharepointIds.siteUrl;
          window.open(OneDriveUrlHelper.getOpenInOneDriveDesktopUrl(fileId, siteId, listId, userEmail, userId, webUrl, fileName), generalModule.isInConentMangerMode() ? "_self" : "_blank");
        }
      }
      else {
        const url = await getListItemWebUrl(await authModule.getGraphAccessToken(), driveId, itemId);
        window.open(`${browseFileInfo.localUrlPrepended}${url}`, browseFileInfo.localUrlPrepended && generalModule.isInConentMangerMode() ? "_self" : "_blank");
      }
      saveToRecent();
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (openInApp)");
    }
    return false;
  }, [props.info.driveId, props.user.account, browseFileInfo, item?.id]);

  const addAttachment = async () => {
    const emailer = emailCreatorfactory.create(languageStrings, props.mode);
    await saveToRecent();
    await emailer.withAttachment([{ id: item?.id, driveId: props.info.driveId, name: props.info.name }]);
    props.dismissPanel();
  };

  const addShareableLink = async () => {
    const emailer = emailCreatorfactory.create(languageStrings, props.mode);
    await saveToRecent();
    await emailer.withShareableLink([
      { id: item?.id, driveId: props.info.driveId, name: props.info.name, webUrl: item?.webUrl }
    ]);
    props.dismissPanel();
  };

  const pinFile = async () => {
    if (props.info.isFromHomePage) {
      setIsAwaitingPinAction(true);
    } else {
      setIsFilePinned(true);
    }

    try {
      const pinItem: IStoreItem = {
        driveId: props.info.driveId,
        name: props.info.name,
        extension: props.info.fileType,
        itemId: item?.id,
        folderId: props.info.folderId,
        fileType: FileTypeEnum.file,
        filePath: props.info.filePath,
        lastModifiedDateTime: props.info.lastModifiedDateTime,
        datePinned: new Date(),
        modifiedBy: props.info.modifiedBy
      };
      props.addPinnedItem(props.user.account.accountId, pinItem);

      const isPinnedSectionCollapsed = props.expanders[expanderConstants.home.pinned];
      if (isPinnedSectionCollapsed) {
        const pinnedExpanderState: IExpander = { toggle: false, property: expanderConstants.home.pinned }
        props.setExpandedItem(pinnedExpanderState);
      }
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (pinFile)");
    }

    if (props.info.isFromHomePage) {
      setIsAwaitingPinAction(false);
      props.dismissPanel();
    }
  };

  const unpinFile = async (deletedItemId?: string) => {
    if (props.info.isFromHomePage) {
      setIsAwaitingPinAction(true);
    } else {
      setIsFilePinned(false);
    }

    try {
      props.removePinnedItem(props.user.account.accountId, {
        // itemId: !item ? props.info.itemId : item.id,
        itemId: deletedItemId ? deletedItemId : (!item ? props.info.itemId : item.id),
        driveId: null
      }, FileTypeEnum.file);
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (unpinFile)");
    }

    if (props.info.isFromHomePage) {
      setIsAwaitingPinAction(false);
      props.dismissPanel();
    }
  };

  const removeRecentItem = async (deletedItemId?: string) => {
    setIsAwaitingRecentAction(true);

    try {
      props.removeRecentItemRedux(props.user.account.accountId, {
        // itemId: !item ? props.info.itemId : item.id,
        itemId: deletedItemId ? deletedItemId : (!item ? props.info.itemId : item.id),
        driveId: props.info.driveId
      }, FileTypeEnum.file)
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (removeRecentItem)");
    }

    setIsAwaitingRecentAction(false);
    props.dismissPanel();
  };

  const downloadAsPdfFile = async () => {
    setIsBusyDownloadingPDF(true);

    try {
      let [pdfContent, fileName] = await Promise.all([
        getFilePdfByteContent({
          id: !item ? props.info.itemId : item.id,
          driveId: props.info.driveId
        }),
        (async () => {
          if (!isInOneDrive.current) {
            const fileNameFromTemplate: string = await getFilenameFromTemplate(
              props.siteInfo,
              props.info.driveId,
              !item ? props.info.itemId : item.id,
              webAddinItem.sharepointIds.siteUrl,
              webAddinItem.sharepointIds.listId,
              webAddinItem.sharepointIds.listItemUniqueId,
              extensions.pdf);
            if (fileNameFromTemplate) {
              return fileNameFromTemplate;
            }
          }
          return null;
        })()
      ]);

      if (!pdfContent) {
        showErrorDialog(languageStrings.DownloadFailure, languageStrings.DownloadAsPdfFailure);
        setIsBusyDownloadingPDF(false);
        return;
      }

      if (!fileName) {
        fileName = `${removeExtension(props.info.name)}.${extensions.pdf}`;
      }

      FileDownLoader.downloadFile(pdfContent, fileName);
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (downloadAsPdfFile)");
      showErrorDialog(languageStrings.DownloadFailure, languageStrings.DownloadAsPdfFailure);
    }
    setIsBusyDownloadingPDF(false);
  };

  const initiateSaveAndConvertAsPdfFile = async () => {
    setIsBusySavingPDF(true);
    try {
      let siteUrl = webAddinItem.sharepointIds.siteUrl;

      let pdfFileName = changeExtensionToPdf(webAddinItem?.name);

      let destinationUrl: string;
      if (isInOneDrive.current) {
        destinationUrl = `${props?.currentDirectory?.webUrl}${props?.currentDirectory?.directory ? `${props.currentDirectory.directory}` : ''}`
      } else if (props?.currentDirectory?.isTeamsRootFolder && !props.currentDirectory.parentId) {
        destinationUrl = await getDriveRootWebUrl(props.currentDirectory.id);
      } else {
        destinationUrl = `${siteUrl}${props?.currentDirectory?.directory ? `/${props.currentDirectory.directory}` : ''}`;
      }

      const fileRequest: FilePreCommitRequest = {
        accessToken: isInOneDrive.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
        destinationUrl,
        siteUrl,
        fileName: pdfFileName,
        autoFolderCreation: false
      }

      const preCommitResult: IFilePreCommitResult = await getFilePreCommitInfo(fileRequest);

      let saveAndConvert = true;
      if (!preCommitResult || preCommitResult.exists === true) {
        setIsSavingDuplicatePDF(true);
        setSelectedOverwriteOption(OneDriveOverWriteEnum.rename.toString());
        saveAndConvert = false;
      }

      if (props.currentSharepointFolder?.enableMinorVersions === true) {
        setShowSelectVersion(true);
        setSelectedCheckinType(CheckinTypes.minorCheckIn);
        saveAndConvert = false;
      }

      if (saveAndConvert) {
        saveAndConvertAsPdfFile();
      }
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (saveAsPdfFile)");
      setIsBusySavingPDF(false);
    }
  };

  const saveAndConvertAsPdfFile = async () => {
    let itemId = !item ? props.info.itemId : item.id;
    let driveId = props.info.driveId;
    let siteUrl = webAddinItem.sharepointIds.siteUrl;

    const request: ConvertAndSaveAsPDFRequest = {
      graphToken: await authModule.getGraphAccessToken(),
      sharePointToken: await authModule.getSharePointAccessToken(),
      tenantGuid: props.user.account.tenantId,
      accountId: props.user.account.accountId,
      driveId,
      itemId,
      siteUrl,
      listId: webAddinItem.sharepointIds.listId,
      teamId: props.workingDirectories?.find(dir => dir.teamGroupId)?.teamGroupId,
      channelId: props.workingDirectories?.find(dir => dir.teamChannelId)?.teamChannelId,
      fileUniqueId: webAddinItem.sharepointIds.listItemUniqueId,
      EnsureUniqueFilename: selectedOverwriteOption === OneDriveOverWriteEnum.rename.toString() ? true : false,
      checkinType: selectedCheckinType,
    }
    try {
      setShowSelectVersion(false);
      setSelectedOverwriteOption("");
      setIsSavingDuplicatePDF(false);

      await apiFileConvertAndSaveAsPDF(request);
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (saveAndConvertAsPdfFile)");
    }
    setIsBusySavingPDF(false);
  }

  const shareToTeamsHandler = () => {
    setMessageSendInProcess(true);
    shareToTeams(
      item?.driveId,
      item?.id,
      true,
      fileName,
      "",
      item?.webUrl
    )
  }

  const getOfficeFileTypeIcon = React.useCallback((props?: IButtonProps, defaultRender?: IRenderFunction<IButtonProps>) => {
    return browseFileInfo && browseFileInfo.iconSrc
      ? <img src={browseFileInfo.iconSrc} className={brandedActionButtonIconStyles} />
      : defaultRender({ ...props });
  }, [browseFileInfo]);

  const multipleOpenOption = (
    <Stack>
      <ActionButton
        allowDisabledFocus
        // iconProps={browseIcon}
        onClick={() => openInWebView()}
        // onRenderIcon={getOfficeFileTypeIcon}
        onRenderIcon={() => browseFileInfo && browseFileInfo.iconSrc
          ? <img src={browseFileInfo.iconSrc} className={brandedActionButtonIconStyles} />
          : <DocumentGlobe20Regular />}
      >
        {`${languageStrings.OpenIn} ${languageStrings.Browser}`}
      </ActionButton>
      {userPermissions?.canOpenItems &&
        <ActionButton
          allowDisabledFocus
          // iconProps={openInAppIcon}
          onClick={() => openInApp()}
          // onRenderIcon={getOfficeFileTypeIcon}
          onRenderIcon={() => browseFileInfo && browseFileInfo.iconSrc
            ? <img src={browseFileInfo.iconSrc} className={brandedActionButtonIconStyles} />
            : <DocumentArrowRight20Regular />}
        >
          {`${languageStrings.OpenIn} ${languageStrings.App}`}
        </ActionButton>}
    </Stack>
  );

  const browseOpenOption = (userPermissions?.canEditListItem || userPermissions?.canOpenItems || props.info.fileType?.toLowerCase() === extensions.pdf) && (
    <ActionButton
      // iconProps={browseIcon}
      allowDisabledFocus
      onClick={() => openInWebView()}
      onRenderIcon={() => <Open20Regular />}
    >
      {`${languageStrings.OpenIn} ${browseFileInfo?.type}`}
    </ActionButton>
  );

  const shareToTeamsButton = teamsContext !== null && (teamsContext.frameContext === "task" || teamsContext.frameContext === "content") && (
    <Stack horizontal>
      <ActionButton
        // iconProps={{ iconName: "TeamsLogo" }}
        onRenderIcon={() => <PeopleTeam20Regular />}
        allowDisabledFocus
        onClick={() => shareToTeamsHandler()}>
        {languageStrings.ShareToTeams}
      </ActionButton>
      {messageSendInProcess && <Spinner size={SpinnerSize.small} />}
    </Stack>
  )

  const openParentInBrowser = (props.user.tenantAllowOpenInSharePoint ?? true) && (
    <Stack horizontal>
      <ActionButton
        // iconProps={{ iconName: "OpenFolderHorizontal" }}
        onRenderIcon={() => <OpenFolder20Regular />}
        allowDisabledFocus
        onClick={() => openParentWebURLInBrowser()}
      >
        {`${languageStrings.OpenFolderInBrowser}`}
      </ActionButton>
      {isOpeningFileLocation && <Spinner size={SpinnerSize.small} />}
    </Stack>
  );

  const pinButton = (
    <Stack horizontal>
      {!isFilePinned ? (
        <ActionButton
          // iconProps={pinIcon}
          onRenderIcon={() => <Pin20Regular />}
          allowDisabledFocus
          onClick={() => pinFile()}
        >
          {languageStrings.PinThisFile}
        </ActionButton>
      ) : (
        <ActionButton
          // iconProps={unpinIcon}
          onRenderIcon={() => <PinOff20Regular />}
          allowDisabledFocus
          onClick={() => unpinFile()}
        >
          {languageStrings.UnpinFile}
        </ActionButton>
      )}
      {isAwaitingPinAction && <Spinner size={SpinnerSize.small} />}
    </Stack>
  );

  const removeRecent = props?.info?.isRecentItem && !props?.info?.cannotbeRemoved && (
    <Stack horizontal>
      <ActionButton
        // iconProps={removeFromRecentIcon}
        onRenderIcon={() => <DeleteArrowBack20Regular />}
        allowDisabledFocus
        onClick={() => removeRecentItem()}
      >
        {languageStrings.RemoveFromRecent}
      </ActionButton>
      {isAwaitingRecentAction && <Spinner size={SpinnerSize.small} />}
    </Stack>
  );

  const attachmentButtons = (props.mode === ModeEnum.mailCompose || props.mode === ModeEnum.mailRead) && (
    <>
      {props.mode === ModeEnum.mailCompose && (
        <ActionButton
          // iconProps={attachIcon}
          onRenderIcon={() => <MailAttach20Regular />}
          allowDisabledFocus
          onClick={async () => await addAttachment()}
        >
          {languageStrings.InsertAsAttachment}
        </ActionButton>
      )}
      {!isMobile && (
        <ActionButton
          // iconProps={linkIcon}
          onRenderIcon={() => props.mode === ModeEnum.mailCompose ? <LinkAdd20Regular /> : <MailLink20Regular />}
          allowDisabledFocus
          onClick={async () => await addShareableLink()}
        >
          {props.mode === ModeEnum.mailCompose ? languageStrings.InsertAsLink : languageStrings.CreateEmailWithLink}
        </ActionButton>
      )}
    </>
  );

  const errorDialog = (
    <Dialog hidden={isErrorDialogHidden} onDismiss={() => setIsErrorDialogHidden(true)} dialogContentProps={dialogContent}>
      <DialogFooter>
        <PrimaryButton autoFocus onClick={() => setIsErrorDialogHidden(true)} text="Ok" />
      </DialogFooter>
    </Dialog>
  );

  const downloadAsPdfButton = !isMobile && userPermissions?.canOpenItems && validPdfExtensions.some(item => props.info?.fileType?.replace(".", "")?.toLowerCase() === item) && (
    <Stack horizontal>
      <ActionButton
        // iconProps={pdfIcon}
        onRenderIcon={() => <DocumentPdf20Regular />}
        allowDisabledFocus
        disabled={isBusyDownloadingPDF}
        onClick={async () => await downloadAsPdfFile()}
      >
        {languageStrings.DownloadAsPdf}
      </ActionButton>
      {isBusyDownloadingPDF && <Spinner size={SpinnerSize.small} />}
    </Stack>
  );

  const saveAsPdfButton = props?.currentDirectory
    && !isMobile
    && userPermissions?.canOpenItems
    && validPdfExtensions.some(item => props.info?.fileType?.replace(".", "")?.toLowerCase() === item)
    && (
      <Stack horizontal>
        <ActionButton
          // iconProps={pdfIcon}
          onRenderIcon={() => <DocumentPdf20Filled />}
          allowDisabledFocus
          disabled={isBusySavingPDF}
          onClick={async () => await initiateSaveAndConvertAsPdfFile()}
        >
          {languageStrings.SaveAsPdf}
        </ActionButton>
        {isBusySavingPDF && <Spinner size={SpinnerSize.small} />}
      </Stack>
    );

  const overwriteVersionFileSelector = !isMobile && (
    <div>
      {isSavingDuplicatePDF && <div style={{ paddingTop: 15, marginBottom: showSelectVersion ? 15 : 0 }}>
        <ChoiceGroup
          defaultSelectedKey={OneDriveOverWriteEnum.rename.toString()}
          options={overwriteOptions}
          onChange={(ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption) => {
            setSelectedOverwriteOption(option.key);
          }}
          label={`${changeExtensionToPdf(webAddinItem?.name)} ${languageStrings.AlreadyExists.toLowerCase()}`}
          styles={choiceGroupStyles}
          required={true}
        />
        {!showSelectVersion &&
          <div className="xb-panel-button-container-left" style={{ paddingTop: 20 }}>
            <Stack tokens={{ childrenGap: 10 }} horizontal>
              <PrimaryButton onClick={() => { saveAndConvertAsPdfFile(); }}>{languageStrings.Save}</PrimaryButton>
              <PrimaryButton text={languageStrings.Cancel} allowDisabledFocus onClick={() => {
                setShowSelectVersion(false);
                setSelectedOverwriteOption("");
                setIsSavingDuplicatePDF(false);
                setIsBusySavingPDF(false);
              }} />
            </Stack>
          </div>
        }
      </div>}
      {showSelectVersion && <VersionSelectorMinMajOnly
        checkinTypeChanged={setSelectedCheckinType}
        onCancel={() => {
          setShowSelectVersion(false);
          setSelectedOverwriteOption("");
          setIsSavingDuplicatePDF(false);
          setIsBusySavingPDF(false);
        }}
        onSave={() => {
          saveAndConvertAsPdfFile();
        }}
        labelFontSize={16}
        paddingTop={0}
        paddingLeft={0} />}
    </div>
  );

  // const checkPii = async (redactPiiData: boolean) => {
  //   setPiiInfo(undefined);
  //   setIsCheckingPii(!redactPiiData);
  //   setIsRedactingData(redactPiiData);
  //   setRefreshPreview(false);

  //   let fileUrl = '';
  //   let siteUrl = '';

  //   const isAspx = props.info?.path?.indexOf('.aspx') > -1;
  //   if (!isAspx) {
  //     if (props.info?.siteUrl) {
  //       fileUrl = props.info?.fullWebUrl
  //       siteUrl = props.info?.siteUrl
  //     } else {
  //       fileUrl = !props?.currentDirectory.directory ? `${props?.currentDirectory.webUrl}/${props.info.name}` : `${props?.currentDirectory.webUrl}/${props?.currentDirectory.directory}/${props.info.name}`;
  //       siteUrl = props?.currentDirectory.webUrl
  //     }

  //     checkPiiMutation({
  //       accessToken: await authModule.getSharePointAccessToken(),
  //       fileUrl,
  //       siteUrl,
  //       forceRecheck: true,
  //       redactPiiData
  //     })
  //       .unwrap()
  //       .then(res => {
  //         setPiiInfo(res);
  //         props.updateFilePii(props.info, res);

  //         setShowRedact(props.user.tenantEnableRedaction && res?.piiDetected && props.info.fileType === extensions.pdf);
  //         setRefreshPreview(redactPiiData);

  //         setIsCheckingPii(false);
  //         setIsRedactingData(false);
  //       }).catch(error => {
  //         setPiiInfo({
  //           piiDetected: false,
  //           piiError: languageStrings.ErrorConnectingToServer
  //         });
  //         setIsCheckingPii(false);
  //         setIsRedactingData(false);
  //       });


  //   } else {
  //     checkGraphPiiMutation({
  //       accessToken: await authModule.getGraphAccessToken(),
  //       driveId: props.info?.driveId,
  //       itemId: props.info?.id,
  //       fileName: props.info?.name,
  //       redactPiiData
  //     })
  //       .unwrap()
  //       .then(res => {
  //         setPiiInfo(res);

  //         setShowRedact(props.user.tenantEnableRedaction && res?.piiDetected && props.info.fileType === extensions.pdf);
  //         setRefreshPreview(redactPiiData);

  //         setIsCheckingPii(false);
  //         setIsRedactingData(false);
  //       }).catch(error => {
  //         setPiiInfo({
  //           piiDetected: false,
  //           piiError: languageStrings.ErrorConnectingToServer
  //         });

  //         setIsCheckingPii(false);
  //         setIsRedactingData(false);
  //       });
  //   }
  // }

  const metaDataUpdated = async (item: any, inputValuesToSave: SharePointInputData[], selectedContentTypeId: string, extention?: string) => {
    generalModule.setIsFileInfoPanelOpen(false);

    if (!props.tenantDisableFileRename) {
      const fileNameValue = inputValuesToSave.find(x => x.internalName === sharePointInternalFileName);
      const newFileName = `${fileNameValue?.value}.${extention}`;

      if (newFileName !== fileName) {
        setWebAddinItem({ ...webAddinItem, name: newFileName })
        setFileName(newFileName);
        setRefreshPreview(true);
      }
    }

    setIsCMFileInfoPanelOpen(false);
    setInfoPanelMode(null);
    getSPFileByID();
  }

  const replaceFileSuccess = async () => {
    setIsCMFileInfoPanelOpen(false);
    setInfoPanelMode(null);
    setRefreshPreview(true);
  }

  const onConfirmDelete = async () => {
    setIsDeletingFile(true);

    try {
      await sendSharepointItemToRecyclebin({
        siteUrl: webAddinItem.sharepointIds.siteUrl,
        sharePointListId: webAddinItem.sharepointIds.listId,
        accessToken: checkIfInOneDrive(webAddinItem.webUrl) ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
        itemId: webAddinItem.sharepointIds.listItemId
      }).unwrap();

      setIsDeletingFile(false);
      if (props.fileDeleted) {
        props.fileDeleted(props.info)
      }
      props.dismissPanel();
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (onConfirmDelete)");
      setIsDeletingFile(false);
    }

    setConfirmDelete(false);
  }

  const downloadFile = async () => {
    setIsDownloadingFile(true);
    const isInOneDrive = props?.currentDirectory?.type == ComponentTypes.OneDrive || props?.currentDirectory?.type == ComponentTypes.OneDriveSubFolder;

    try {
      const driveId: string = !isInOneDrive
        ? props.info?.driveId
        : props?.oneDriveRootDetails?.driveId;

      let fileName: string = webAddinItem.name;

      if (!isInOneDrive) {
        const fileNameFromTemplate: string = await getFilenameFromTemplate(
          props.siteInfo,
          driveId,
          !item ? props.info.itemId : item.id,
          webAddinItem.sharepointIds.siteUrl,
          webAddinItem.sharepointIds.listId,
          webAddinItem.sharepointIds.listItemUniqueId
        );
        if (fileNameFromTemplate) {
          fileName = fileNameFromTemplate;
        }
      }

      const downloadItem = {
        driveId: driveId,
        itemId: item.id,
        name: fileName
      };

      const downloadRequestPayload = {
        accessToken: await authModule.getGraphAccessToken(),
        items: [downloadItem]
      };

      await FileDownLoader.downloadFileStream(downloadRequestPayload);
    } catch (error) {
      logger(error, "FileOptionsPanel.tsx (downloadFile)");
      showErrorDialog(languageStrings.DownloadFailure, error?.message || languageStrings.DownloadFailure);
    }

    setIsDownloadingFile(false);
  }

  // const piiCheck = props.user.tenantEnablePII && props.info.pii && (
  //   <Stack horizontal>
  //     <ActionButton
  //       iconProps={privacySensitiveIcon}
  //       allowDisabledFocus
  //       onClick={() => checkPii(false)}
  //       disabled={isLoadingCheckPii || isLoadingCheckGraphPii}
  //     >
  //       {languageStrings.PrivacySensitiveDisplay}
  //       {(!isLoadingCheckPii || !isLoadingCheckGraphPii) && (
  //         <TooltipHost
  //           content={<PiiTooltip isLoading={isLoadingCheckPii || isLoadingCheckGraphPii} PIIDetected={piiInfo?.piiDetected} PII={piiInfo?.pii} piiError={piiInfo?.piiError} />}
  //           calloutProps={{ gapSpace: 0, calloutWidth: 250 }}
  //           styles={{
  //             root: {
  //               display: "inline-block"
  //             },
  //           }}
  //           delay={TooltipDelay.zero}
  //         >
  //           <span>
  //             {piiInfo?.piiDetected === false && piiInfo.pii === '-' && (
  //               <Icon
  //                 style={{ color: "#498205", paddingTop: "7px", paddingLeft: "5px", fontWeight: 800 }}
  //                 iconName="Checkmark"
  //               />
  //             )}
  //             {piiInfo?.piiDetected === false && !piiInfo.pii && !piiInfo.piiError && (
  //               <Icon
  //                 style={{ paddingTop: "3px", paddingLeft: "1px", fontWeight: 400, fontSize: 24 }}
  //                 iconName="StatusCircleQuestionMark"
  //               />
  //             )}
  //             {piiInfo?.piiError && (
  //               <Icon
  //                 style={{ color: '#a80000', paddingTop: "3px", paddingLeft: "1px", fontWeight: 500, fontSize: 30 }}
  //                 iconName="StatusCircleExclamation"
  //               />
  //             )}
  //             {piiInfo?.piiDetected === true && !piiInfo?.piiError && (
  //               <Icon
  //                 style={{ color: "#d13438", paddingTop: "7px", paddingLeft: "5px", fontWeight: 800 }}
  //                 iconName="CalculatorMultiply"
  //               />

  //             )}
  //           </span>
  //         </TooltipHost>
  //       )}
  //     </ActionButton>


  //     {(isCheckingPii) && <Spinner size={SpinnerSize.small} />}

  //   </Stack>
  // );

  // const piiRedact = showRedact && (
  //   <Stack horizontal>
  //     <ActionButton
  //       iconProps={redactIcon}
  //       allowDisabledFocus
  //       onClick={() => checkPii(true)}
  //       disabled={isCheckingPii || isRedactingData}
  //       text={languageStrings.PrivacySensitiveRedact}
  //     />
  //     {(isRedactingData) && <Spinner size={SpinnerSize.small} />}
  //   </Stack>
  // );

  const [isApprovalsPanelOpen, setIsApprovalsPanelOpen] = React.useState(false);
  const approvalsButton = props.user.tenantEnableApprovalHooks && approvalFlowsAvailable && (
    <>
      <Stack horizontal>
        <ActionButton
          // iconProps={documentApprovalIcon}
          onRenderIcon={() => <FlowDot20Regular />}
          allowDisabledFocus
          onClick={() => setIsApprovalsPanelOpen(true)}
        >
          {languageStrings.Automation}
        </ActionButton>
      </Stack>
      {isApprovalsPanelOpen && <WebPanel isOpen={isApprovalsPanelOpen} closePanel={() => setIsApprovalsPanelOpen(false)} headerText={languageStrings.AutomationFlowRequest} styles={{ main: { overflow: "unset" } }}>
        <AutomationPanel file={props.info} isGraphQuery={true} tenantEnablePII={props.user.tenantEnablePII} closeClicked={() => setIsApprovalsPanelOpen(false)} />
      </WebPanel>}
    </>
  );

  const [isSigningsPanelOpen, setIsSigningsPanelOpen] = React.useState(false)
  const signingRequestButton =
    CacheHelper.get(DocubirdCache.signingEnabled) === true && signingFlowsAvailable &&
    validSigningRequestExtensions.includes(props?.info?.fileType?.toUpperCase()) && (
      <>
        <Stack horizontal>
          <ActionButton
            // iconProps={SigningRequestIcon}
            onRenderIcon={() => <DocumentSignature20Regular />}
            allowDisabledFocus
            onClick={() => setIsSigningsPanelOpen(true)}
          >
            {languageStrings.SigningRequest}
          </ActionButton>
        </Stack>
        {isSigningsPanelOpen && <WebPanel isOpen={isSigningsPanelOpen} closePanel={() => setIsSigningsPanelOpen(false)} headerText={languageStrings.SigningRequest} styles={{ main: { overflow: "unset" } }}>
          <SigningPanel
            file={props.info}
            tenantEnablePII={props.user.tenantEnablePII}
            closeClicked={() => setIsSigningsPanelOpen(false)}
            isContentManager={false}
          />
        </WebPanel>}
      </>
    );

  const [isCMFileInfoPanelOpen, setIsCMFileInfoPanelOpen] = React.useState(false);
  const fileInfoButton = (
    <React.Fragment>
      <Stack horizontal>
        <ActionButton
          // iconProps={fileInfoIcon}
          onRenderIcon={() => <Info20Regular />}
          allowDisabledFocus
          onClick={async () => {
            setInfoPanelMode(InfoPanelMode.Update);
            setIsCMFileInfoPanelOpen(true);
          }}
        >
          {languageStrings.Properties}
        </ActionButton>
      </Stack>
      {isCMFileInfoPanelOpen && infoPanelMode === InfoPanelMode.Update && <CMFileInfoPanel panelIsOpen={isCMFileInfoPanelOpen} closeOnSuccess={metaDataUpdated} closePanel={() => { setIsCMFileInfoPanelOpen(false); generalModule.setIsFileInfoPanelOpen(false) }} webAddinItem={webAddinItem} infoPanelMode={infoPanelMode} userPermissions={userPermissions} />}
    </React.Fragment>
  );

  const [isSharePanelOpen, setIsSharePanelOpen] = React.useState(false);

  const sharePanelModeRef = React.useRef<SharePanelMode>(SharePanelMode.Share);
  const openSharePanel = React.useCallback((mode: SharePanelMode) => {
    sharePanelModeRef.current = mode;
    setIsSharePanelOpen(true);
  }, []);

  const shareButton = props.enableSharing && (
    <Stack horizontal>
      <ActionButton
        // iconProps={shareIcon}
        onRenderIcon={() => <Share20Regular />}
        allowDisabledFocus
        onClick={async () => {
          openSharePanel(SharePanelMode.Share);
        }}
      >
        {languageStrings.Share}
      </ActionButton>
    </Stack>
  )

  const copyLinkButton = props.enableSharing && (
    <Stack horizontal>
      <ActionButton
        // iconProps={copyLinkIcon}
        onRenderIcon={() => <Link20Regular />}
        allowDisabledFocus
        onClick={async () => {
          openSharePanel(SharePanelMode.Copy);
        }}
      >
        {languageStrings.CopyLink}
      </ActionButton>
    </Stack>
  )

  const fileReplaceButton = userPermissions?.canDeleteListItem && (
    <React.Fragment>
      <Stack horizontal>
        <ActionButton
          // iconProps={fileReplaceIcon}
          onRenderIcon={() => <DocumentLandscapeSplitHint20Regular />}
          allowDisabledFocus
          onClick={() => {
            setRefreshPreview(false);
            setInfoPanelMode(InfoPanelMode.Replace);
            setIsCMFileInfoPanelOpen(true);
          }}
        >
          {languageStrings.ReplaceFile}
        </ActionButton>
      </Stack>
      {isCMFileInfoPanelOpen && infoPanelMode === InfoPanelMode.Replace && <CMFileInfoPanel panelIsOpen={isCMFileInfoPanelOpen} closeOnSuccess={replaceFileSuccess} closePanel={() => setIsCMFileInfoPanelOpen(false)} webAddinItem={webAddinItem} infoPanelMode={infoPanelMode} userPermissions={userPermissions} />}
    </React.Fragment>
  );

  const fileDeleteButton = userPermissions?.canDeleteListItem && (
    <Stack horizontal>
      <ActionButton
        // iconProps={fileDeleteIcon}
        disabled={isDeletingFile}
        // styles={confirmDelete && confirmDeleteButtonStyles}
        onRenderIcon={() => <Delete20Regular />}
        allowDisabledFocus
        text={confirmDelete ? `${languageStrings.Confirm} ${languageStrings.Delete}?` : languageStrings.Delete}
        onClick={() => {
          if (!confirmDelete) {
            setConfirmDelete(true);
          }
        }}
      />
      {isDeletingFile && <Spinner size={SpinnerSize.small} styles={{ root: { paddingLeft: 8 } }} />}
      {confirmDelete && !isDeletingFile && <TooltipHost content={languageStrings.Confirm} >
        <ActionButton
          // iconProps={{ iconName: "Accept" }}
          onRenderIcon={() => <Checkmark20Regular />}
          onClick={() => onConfirmDelete()}
        />
      </TooltipHost>}
      {confirmDelete && !isDeletingFile && <TooltipHost content={languageStrings.Cancel} >
        <ActionButton
          // iconProps={{ iconName: "Cancel" }}
          onRenderIcon={() => <Dismiss20Regular />}
          onClick={() => setConfirmDelete(false)}
        />
      </TooltipHost>}
    </Stack>
  );

  const fileDownloadButton = userPermissions?.canOpenItems && props.info?.fileType !== "url" && (
    <React.Fragment>
      <Stack horizontal>
        <ActionButton
          // iconProps={fileDownloadIcon}
          onRenderIcon={() => <ArrowDownload20Regular />}
          disabled={isDownloadingFile}
          allowDisabledFocus
          text={languageStrings.Download}
          onClick={() => downloadFile()}
        >
          {isDownloadingFile && <Spinner size={SpinnerSize.small} />}
        </ActionButton>
      </Stack>
    </React.Fragment>
  );

  const moveFileButtons = isFilePinned && pinnedFileIndex > -1 && (
    <>
      {pinnedFileIndex !== 0 &&
        <Stack>
          <ActionButton
            // iconProps={iconUp}
            onRenderIcon={() => <ArrowBetweenUp20Regular />}
            allowDisabledFocus
            onClick={() => props.MovePinnedItemUp(props.user.account.accountId, pinnedFileIndex)}
          >
            {languageStrings.MoveItemUp}
          </ActionButton>
          {isAwaitingRecentAction && <Spinner size={SpinnerSize.small} />}
        </Stack>}
      {pinnedFileIndex !== props.pinned.pinnedItems.length - 1 &&
        <Stack>
          <ActionButton
            // iconProps={iconDown}
            onRenderIcon={() => <ArrowBetweenDown20Regular />}
            allowDisabledFocus
            onClick={() => props.MovePinnedItemDown(props.user.account.accountId, pinnedFileIndex)}
          >
            {languageStrings.MoveItemDown}
          </ActionButton>
          {isAwaitingRecentAction && <Spinner size={SpinnerSize.small} />}
        </Stack>}
    </>
  )

  return (
    <Panel
      headerText={fileName}
      isLightDismiss={true}
      isOpen={props.info.isOpen}
      onDismiss={props.dismissPanel}
      closeButtonAriaLabel="Close"
      type={PanelType.custom}
      customWidth={!generalModule.isInConentMangerMode() ? "300px" : "350px"}
    >
      <div style={breadCrumbContainerStyles}>
        {filePathArray?.length > 0 && <Breadcrumb
          styles={breadCrumbStyles}
          items={filePathArray.map(x => ({ text: x, key: x }))}
        />}
      </div>
      {!props.hideAutoPreview && validPreviewExtension.some(item => props.info?.fileType?.replace(".", "")?.toLowerCase() === item) && props.info.fileType !== "url" && <PreviewFile fileItem={item} unknownItem={unknownItem} refreshPreview={refreshPreview} />}
      {(isSavingDuplicatePDF || showSelectVersion) && overwriteVersionFileSelector}
      {!isSavingDuplicatePDF && !showSelectVersion &&
        <>
          {shareToTeamsButton}
          {/* {piiCheck} */}
          {/* {piiRedact} */}
          {pinButton}
          {removeRecent}
          {browseFileInfo?.type === officeFileType.Browser || (props.currentSharepointFolder?.disableOpenInApp && !browseFileInfo?.isOfficeFile)
            ? browseOpenOption
            : multipleOpenOption}
          {openParentInBrowser}
          {attachmentButtons}
          {downloadAsPdfButton}
          {saveAsPdfButton}
          {shareButton}
          {copyLinkButton}
          {isSharePanelOpen && <CMFileSharePanel panelIsOpen={isSharePanelOpen} closePanel={() => setIsSharePanelOpen(false)} items={[{ ...props.info, sharepointIds: webAddinItem.sharepointIds }]} mode={sharePanelModeRef.current} />}
          {approvalsButton}
          {signingRequestButton}
          {fileInfoButton}
          {fileReplaceButton}
          {fileDownloadButton}
          {versionHistoryButton}
          {publishButton}
          {unpublishButton}
          {fileDeleteButton}
          {moveFileButtons}
          {errorDialog}
        </>
      }
    </Panel>
  );
};

export default connector(FileOptionPanel);
